import React from 'react';
import "./Product.css";
import { useStateValue } from './StateProvider'

function Product({ id, title, image, price, rating }) {
    const [{}, dispatch] = useStateValue();

    const addToBasket = () => {
    // Adding Item to Basket...
    dispatch({
        type: 'ADD_TO_BASKET',
        item: {
            id: id,
            title: title,
            image: image,
            price: price,
            rating: rating,
        },
    });
};
    return (
        <div className="product">
            <div classNam="product__info">
                <p>{title}</p>
                <p className="product__price">
                    <small>$ </small>
                    <strong>{price}</strong>
                </p>
                <div className="product__rating">
                    {Array(rating)
                    .fill()
                    .map((_, i) => (<p>⭐</p>))
                    }
                </div>
            </div>
            <img src={image} alt={title}></img>
            <button onClick= {addToBasket}>Add to Cart</button>
        </div>
    );
}

export default Product;
